<header class="navbar fixed-top p-0 shadow">
  <ng-container *ngIf="(isScreenSmall$ | async) && showNavigation; else desktopHeader" class="top-navigation-container">
    <app-top-navigation-mobile class="w-100"></app-top-navigation-mobile>
  </ng-container>
  <ng-template #desktopHeader>
    <app-top-navigation class="w-100"></app-top-navigation>
    <app-bread-crumb-navigation class="w-100"></app-bread-crumb-navigation>
  </ng-template>
</header>
